import Vue from 'vue'
import Router from 'vue-router'
import Signup from './views/Signup.vue'
import SignupB from './views/SignupB.vue'
import CompleteSignup from './views/CompleteSignup.vue'
import Login from './views/Login.vue'
import LoginB from './views/LoginB.vue'
import UserSetting from './views/UserSetting.vue'
import EditPassword from './views/EditPassword.vue'
import EditUserFullName from './views/EditUserFullName.vue'
import ResetPassword from './views/ResetPassword'
import AboutUs from './views/AboutUs'

import LoginSms1 from './views/LoginSms1.vue'
import LoginSms2 from './views/LoginSms2.vue'
import LoginSms from './views/LoginSms.vue'

import JoinedGroups from './views/JoinedGroups.vue'
import CreateGroup from './views/CreateGroup.vue'
import GroupHome from './views/GroupHome.vue'
import AddMember from './views/AddMember.vue'
import RemoveMember from './views/RemoveMember.vue'
// import VerifyInviteCode from './views/VerifyInviteCode.vue'
import JoinGroupWithInviteCode from './views/JoinGroupWithInviteCode.vue'
import GroupSetting from './views/GroupSetting.vue'
import GroupQRCode from './views/GroupQRCode.vue'
import GroupInviteLink from './views/GroupInviteLink'
import EditGroupName from './views/EditGroupName'
import EditInviteCode from './views/EditInviteCode'

import CreateAlbum from './views/CreateAlbum.vue'
import AlbumHome from './views/AlbumHome.vue'
import EditAlbumName from './views/EditAlbumName.vue'
import DeletePhoto from './views/DeletePhoto.vue'

import Home from './views/Home.vue'
import HomeB from './views/HomeB.vue'
import Page404 from './views/Page404.vue'
import Main from './views/Main.vue'
import api from './lib/api'
import storage from './lib/storage'
import logger from './lib/logger'

import {
  initWxJsApiConfig
} from './lib/wx_jsapi';
import util from './lib/util';

Vue.use(Router)

// 路由meta字段解释
// public: true, 不需要登录
// groupMember: true, 必须是group成员才能访问
const router = new Router({
  routes: [
    { path: '/', component: Home, meta: { public: true } },
    // { path: '/home', component: Home, meta: { public: true } },
    { path: '/signup', component: Signup, meta: { public: true } },
    { path: '/signup_b', component: SignupB, meta: { public: true } },
    { path: '/complete_signup', component: CompleteSignup, meta: { public: true } },
    { path: '/reset_password', component: ResetPassword, meta: { public: true } },
    { path: '/login', component: Login, meta: { public: true } },
    { path: '/login_b', component: LoginB, meta: { public: true } },
    { path: '/login_sms1', component: LoginSms1, meta: { public: true } },
    { path: '/login_sms2', component: LoginSms2, meta: { public: true } },
    { path: '/login_sms', component: LoginSms, meta: { public: true } },
    {
      path: '/user/:userId',
      component: Main,
      children: [
        { path: '', component: JoinedGroups },
        { path: 'joined_groups', component: JoinedGroups },
        { path: 'user_setting', component: UserSetting },
        { path: 'edit_password', component: EditPassword },
        { path: 'edit_full_name', component: EditUserFullName },
        { path: 'about_us', component: AboutUs }
      ]
    },
    { path: '/user/:userId/group/create', component: CreateGroup }, 
    { path: '/group/:groupId', component: GroupHome, meta: { groupMember: true } },
    { path: '/group/:groupId/create_album', component: CreateAlbum, meta: { groupMember: true } },
    { path: '/group/:groupId/album/:albumId', component: AlbumHome, meta: { groupMember: true } },
    { path: '/group/:groupId/album/:albumId/delete_photo', component: DeletePhoto, meta: { groupMember: true } },
    { path: '/group/:groupId/album/:albumId/edit_name', component: EditAlbumName, meta: { groupMember: true } },
    { path: '/group/:groupId/add_member', component: AddMember, meta: { groupMember: true } },
    { path: '/group/:groupId/remove_member', component: RemoveMember, meta: { groupMember: true } },
    // { path: '/group/:groupId/verify_invite_code/:groupOwnerName/:groupName', component: VerifyInviteCode, meta: { public: true } },
    { path: '/group/:groupId/join_group/:inviteCode/:groupName/:groupOwnerName', component: JoinGroupWithInviteCode, meta: { public: true } },
    { path: '/group/:groupId/setting', component: GroupSetting, meta: { public: true } },
    { path: '/group/:groupId/edit_group_name', component: EditGroupName, meta: { public: true } },
    { path: '/group/:groupId/edit_invite_code', component: EditInviteCode, meta: { public: true } },
    { path: '/group/:groupId/qrcode', component: GroupQRCode, meta: { public: true } },
    { path: '/group/:groupId/invite_link', component: GroupInviteLink, meta: { public: true } },
    { path: '*', component: Page404 }
  ]
})

router.beforeEach(async (to, _, next) => {
  if (!to.meta.public) {
    // 如果当前router不是public的
    try {
      const loginRes = await api.isLogin()
      if (!loginRes.userId) {
        // 如果没有登录，或者accessToken失效，去登录
        localStorage.setItem(storage.keys.loginRedirectUrl, to.fullPath)
        next({ path: '/login_sms' })
        return
      } 

      if (to.meta.groupMember) {
        // 如果需要检查成员身份
        const isGroupMember = (await api.isGroupMember(to.params.groupId)).isGroupMember
        if (!isGroupMember) {
          // 如果不是群成员, 那么跳转到用户加入的群
          localStorage.setItem(storage.keys.loginRedirectUrl, to.fullPath)
          const currentUserId = (await api.isLogin()).userId
          next(`/user/${currentUserId}/joined_groups`)
          return
        }
      }
      next()
      return
    } catch (err) {
      logger.error('router.js:beforeEach', err)
      alert('服务器错误')
      next(false)
      return
    }
  }
  
  next()
})


router.beforeEach(async (to, _, next) => {
  if(!window.initwxconfig) {
    if (util.isInWeixin()) {
      try {
        await initWxJsApiConfig();
        window.initwxconfig = true;
      } catch (error) {
        console.log(error)
        next();
      }
     
    } 
  }
  next();
})
export default router
